var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-header text-center border-bottom-0" }, [
      _c("h1", { staticClass: "h4" }, [_vm._v(_vm._s(_vm.$t("design.forms")))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body grid-kernel system_colors" },
      [
        _c(
          "div",
          { staticClass: "form form-lines" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "Radio",
                  horizontal: "",
                  "label-cols": 3,
                  "label-size": "Default",
                  label: "Button Radio:"
                }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "4" } },
                      [
                        _c("radio", {
                          ref: "radio",
                          attrs: { label: "Radio", name: "test" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "4" } },
                      [
                        _c("radio", {
                          ref: "radio2",
                          attrs: { label: "Radio 2", name: "test" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "Checkbox",
                  horizontal: "",
                  "label-cols": 3,
                  "label-size": "Default",
                  label: "Checkbox:"
                }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "4" } },
                      [
                        _c("checkBox", {
                          ref: "chbx",
                          attrs: { label: "Check", checked: "value" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "4" } },
                      [
                        _c("checkBox", {
                          ref: "chbx",
                          attrs: { label: "Check 2", checked: "value" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "Buttons",
                  horizontal: "",
                  "label-cols": 3,
                  "label-size": "Default",
                  label: "Main buttons:"
                }
              },
              [
                _c("b-btn", { attrs: { variant: "primary" } }, [
                  _vm._v("primary")
                ]),
                _vm._v(" "),
                _c("b-btn", { attrs: { variant: "outline-primary" } }, [
                  _vm._v("outline-primary")
                ]),
                _vm._v(" "),
                _c("b-btn", { attrs: { variant: "secondary" } }, [
                  _vm._v("secondary")
                ]),
                _vm._v(" "),
                _c("b-btn", { attrs: { variant: "outline-primary" } }, [
                  _vm._v("outline-secondary")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "Buttons",
                  horizontal: "",
                  "label-cols": 3,
                  "label-size": "Default",
                  label: "State buttons:"
                }
              },
              [
                _c("b-btn", { attrs: { variant: "info" } }, [_vm._v("info")]),
                _vm._v(" "),
                _c("b-btn", { attrs: { variant: "outline-info" } }, [
                  _vm._v("outline-info")
                ]),
                _vm._v(" "),
                _c("b-btn", { attrs: { variant: "success" } }, [
                  _vm._v("success")
                ]),
                _vm._v(" "),
                _c("b-btn", { attrs: { variant: "outline-success" } }, [
                  _vm._v("outline-success")
                ]),
                _vm._v(" "),
                _c("b-btn", { attrs: { variant: "danger" } }, [
                  _vm._v("danger")
                ]),
                _vm._v(" "),
                _c("b-btn", { attrs: { variant: "outline-danger" } }, [
                  _vm._v("outline-danger")
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          { staticClass: "mt-4" },
          [
            _c(
              "b-col",
              { attrs: { lg: "6" } },
              [
                _c("h5", { staticClass: "mb-4 border-bottom pb-2" }, [
                  _vm._v("Form example")
                ]),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      id: "fieldset1",
                      label: "Name",
                      "label-for": "input1"
                    }
                  },
                  [_c("b-form-input", { attrs: { id: "input1" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      id: "fieldset2",
                      label: "Email:",
                      "label-for": "input2"
                    }
                  },
                  [
                    _c("b-form-input", {
                      attrs: { id: "input2", type: "email" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "fieldset3",
                              label: "Password:",
                              "label-for": "input3"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { id: "input3", type: "password" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "fieldset4",
                              label: "Confirm password:",
                              "label-for": "input4"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { id: "input4", type: "password" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { lg: "6" } },
              [
                _c("h5", { staticClass: "mb-4 border-bottom pb-2" }, [
                  _vm._v("Form example messages")
                ]),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    class: { feedback: _vm.showValidation },
                    attrs: {
                      id: "fieldset1a",
                      label: "Name",
                      "label-for": "input1a"
                    }
                  },
                  [
                    _c("b-form-input", { attrs: { id: "input1a" } }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showValidation,
                            expression: "showValidation"
                          }
                        ],
                        staticClass: "alert alert-danger feedback-message"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("validation.input.special_characters")
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    class: { feedback: _vm.showValidation },
                    attrs: {
                      id: "fieldset2a",
                      label: "Email:",
                      "label-for": "input2a"
                    }
                  },
                  [
                    _c("b-form-input", {
                      attrs: { id: "input2a", type: "email" }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showValidation,
                            expression: "showValidation"
                          }
                        ],
                        staticClass: "alert alert-danger feedback-message"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("validation.input.email")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "fieldset3a",
                              label: "Password:",
                              "label-for": "input3a"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { id: "input3a", type: "password" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            class: { feedback: _vm.showValidation },
                            attrs: {
                              id: "fieldset4a",
                              label: "Confirm password:",
                              "label-for": "input4a"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { id: "input4a", type: "password" }
                            }),
                            _vm._v(" "),
                            _c(
                              "transition",
                              { attrs: { name: "slide-down" } },
                              [
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showValidation,
                                        expression: "showValidation"
                                      }
                                    ],
                                    staticClass:
                                      "alert alert-danger feedback-message"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "validation.input.password_confirm"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Styles/Forms.vue?vue&type=template&id=427740dd&scoped=true&
// module id = null
// module chunks = 